module.exports = __webpack_public_path__ + "static/img/lianxi_pic.c7880006.png";